import {formatNumber} from '@edna/utils';

import {TTariffPricingDetail} from 'src/containers/TariffsCatalog';

import {TConnectedTariffResponse} from './definitions';

export const WHATSAPP_COLUMNS_WIDTH = 'repeat(4, calc((100% - 20px * 3) / 4))';
export const COLUMNS_WIDTH = 'repeat(3, calc((100% - 20px * 2) / 3))';

export const formatPrice = (price: number | string, maximumFractionDigits = 2) =>
  formatNumber(Number(price), {maximumFractionDigits});

export const getPrice = (label: string, pricingDetails?: TTariffPricingDetail[]) =>
  pricingDetails?.find((price) => price.label === label)?.data?.price ?? '';

const correctionMultiplier = 100;

export const getFinalPrice = (
  price?: number | string | null,
  coefficient?: number,
  hasFormatter?: boolean,
) => {
  if (!price || !coefficient || typeof price !== 'number') {
    return;
  }

  const finalPrice = Math.trunc(price * coefficient * correctionMultiplier) / correctionMultiplier;

  return hasFormatter ? formatPrice(finalPrice) : finalPrice;
};

export const getLinkedSubjects = (
  connectedTariffs: TConnectedTariffResponse[] = [],
): Record<number, number[]> => {
  if (!connectedTariffs.length) {
    return {};
  }

  return connectedTariffs.reduce<Record<number, number[]>>((result, connectedTariff) => {
    const tariffId = connectedTariff.active.selectedTariffId;

    if (result[tariffId]) {
      return {...result, [tariffId]: [...result[tariffId], connectedTariff.active.subjectId]};
    }

    return {...result, [tariffId]: [connectedTariff.active.subjectId]};
  }, {});
};
